import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=25f629b0&"
import script from "./SettingsButton.vue?vue&type=script&lang=ts&"
export * from "./SettingsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports